import { useState, useEffect } from "react";
import "../css/zto.css";
import "../css/app.css";

import Header from "../components/Header";
import Footer from "../components/Footer";
import BannerSection from "../components/home/BannerSection";
import DeliverySection from "../components/home/DeliverySection";
import ShippingSection from "../components/home/ShippingSection";
import CommitmentSection from "../components/home/CommitmentSection";
import QuoteSection from "../components/home/QuoteSection";
import AccordionSection from "../components/home/AccordionSection";
import Achievement from "../components/home/Achievement";
import ElevatingExcellence from "../components/home/ElevatingExcellence";

const Home = () => {
  return (
    <div>
      <Header />
      <BannerSection />
      <ShippingSection />
      <DeliverySection />
      <Achievement />
      <ElevatingExcellence />
      {/* <CommitmentSection /> */}
      <QuoteSection />
      <AccordionSection />
      <Footer />
    </div>
  );
};

export default Home;
